import { convertArrayToObject, copyObject } from '../../../../utils'

import { ConfigDocumentsT, filterDocuments } from '../DocumentsTab/ConfigDocuments'

import * as _ from 'lodash'
import { DocumentObj } from '../InitObjectJob'
import { DocumentT, JobT } from '../../../../types/Job'

export const prepareDocuments = (job: JobT): [Array<ConfigDocumentsT>, Array<DocumentT>] => {
    const addressState = _.isArray(job.locations) && job.locations[0] && job.locations[0].addressState
    const listDocuments = filterDocuments(job.jobType,job.jobStatus, addressState)
    // console.log("listDocuments", listDocuments)
  
    let newDocuments = []
    listDocuments.map((item, index) => {
        let document: DocumentT = copyObject(DocumentObj)
        if (job.documents[item.name]) {
            document = copyObject({ ...document, ...job.documents[item.name] })
        } else {
            document.variables = item.variables;
            document.name = item.name
        }

        if (item.defaultAgreement) {
            document.defaultAgreement = document.defaultAgreement ? document.defaultAgreement : item.defaultAgreement;
            document.agreement = document.agreement ? document.agreement : []
        }
        document.name = item.name
        document.active = true;
        document.title = item.title
        newDocuments.push(copyObject(document))
    })

    let cloneNewDocuments = copyObject(newDocuments);

    // switch active if not exists 
    Object.keys(job.documents).map((key, index) => {
        const documentExists = newDocuments.find((d) => d.name == key)
        if (!documentExists) {
            let document = { ...DocumentObj, ...job.documents[key] }
            document.active = false
            cloneNewDocuments.push(copyObject(document))
        }
    })

    return [listDocuments, cloneNewDocuments]
}


export const FilterDocuments = {
    callback: (job: JobT): JobT => {
        let cloneJob = copyObject(job)
        if (!cloneJob || !_.has(cloneJob, "documents")) {
            return null
        }
        // if (!cloneJob.documents) {
        //     cloneJob.documents = copyObject(DocumentsObj);
        // }
        let currDoc = null
        const [listDocuments, jobDocuments] = prepareDocuments(cloneJob)
        currDoc = copyObject(convertArrayToObject(jobDocuments, 'name'))

        cloneJob.documents = currDoc
        return cloneJob;

    },
    priority: 1,
    name: "documents",
}


